import * as ActionTypes from 'actions/beneficiaries'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  fetchedLocked: false,
  isSaving: false,
  currentFy: getFiscalYearTimestamps(7), // the fiscal year starts in July (Partner is given a month to confirm - nomination process).
  beneficiaries: [],
  beneficiary: {},
  isLocked: false,
  fixedAmount: 0,
  fixedRem: 0,
  effectiveDate: '',
  comments: '',
}

// Updates error message to notify about the failed fetches.
export default function beneficiaries(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BENEFICIARY_LOCK_GET:
    case ActionTypes.BENEFICIARY_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.BENEFICIARY_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        beneficiaries: action.beneficiaries,
        beneficiary: action.beneficiary,
      }
    case ActionTypes.BENEFICIARY_LOCK_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetchedLocked: true,
        isLocked: action.isLocked,
        fixedAmount: action.fixedAmount,
        fixedRem: action.fixedRem,
        effectiveDate: action.effectiveDate,
        comments: action.comments,
      }
    case ActionTypes.BENEFICIARY_SAVING:
      return {
        ...state,
        isSaving: true,
      }
    case ActionTypes.BENEFICIARY_SAVING_COMPLETE:
      return {
        ...state,
        isSaving: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/beneficiaries.js